import React from 'react';

export const EmptySelect = () => {
  return (
    <div className="empty__main-content">
        <p>
            Select a Journal
            <br/>
            Create an entry
        </p>

        <i className="far fa-star fa-4x mt-5"></i>
    </div>
  )
};
